import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'src/utils/axios'
import { backend } from 'src/config'

export const fetchTasks = createAsyncThunk(
  'FETCH_TASKS',
  async (_, { rejectWithValue, getState }) => {
    try {
      const {
        tasks: { page, offset },
      } = getState()
      const response = await axios.get(
        `${backend}/api/task?page=${page}&offset=${offset}`
      )

      return response.data
    } catch (error) {
      console.error('Error in fetch tasks', error)
      return rejectWithValue([], error)
    }
  }
)

export const changeTaskStatus = createAsyncThunk(
  'CHANGE_TASKS_STATUS',
  async ({ taskId, statusId }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${backend}/api/task/status/${taskId}?statusId=${statusId}`
      )

      return response.data
    } catch (error) {
      console.error('Error in fetch tasks', error)
      return rejectWithValue([], error)
    }
  }
)

export const changeTaskAssign = createAsyncThunk(
  'CHANGE_TASKS_ASSIGN',
  async ({ taskId, userId }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${backend}/api/task/assign/${taskId}?userId=${userId}`
      )

      return response.data
    } catch (error) {
      console.error('Error in fetch tasks', error)
      return rejectWithValue([], error)
    }
  }
)
